import Svg from 'components/UI/SVG'
import { useStaticQuery, graphql } from 'gatsby'
import { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import getEnglishStrings from 'utils/getEnglishStrings'
import ExclamationIcon from 'images/error-exclamation-mark.svg'

export default function ChangelogErrorState(): ReactElement {
  const errorData = useStaticQuery<Queries.ChangelogContentWrapperQuery>(graphql`
    query ChangelogContentWrapper {
      directus {
        general_translations {
          strings {
            languages_code {
              code
            }
            error_loading
          }
        }
      }
    }
  `)

  const errorStrings = getEnglishStrings(errorData.directus?.general_translations?.strings)
  return (
    <Flex sx={{ gap: '0.8rem', alignItems: 'center' }}>
      <Svg svg={ExclamationIcon} sx={{ width: 'fit-content !important' }} />
      <Text color="red">{errorStrings?.error_loading}</Text>
    </Flex>
  )
}
